import { connect } from 'pwa-helpers';
import { html } from "lit";
import { customElement, property, state } from 'lit/decorators.js'
import store from '../../store/store';
import { createMessage } from '../../common/utils/util';
import { StoreState } from '../../store/store.interface';
import { selectRequest } from './store/search.selector';
import { BaseComponent } from '../base-component/base-component';
import { selectV2Request } from '../search-v2/store/search-v2.selectors';
import { TAB_NAMES } from '../tabbed-search/constants';


/**
 * An element to display the current page within the search results.
 * @csspart term - The <span> containing the number representing the search term.
 */
@customElement('mhecomm-search-page-heading')
export class SearchResultsHeading extends connect(store)(BaseComponent) {

  /**
   * The message to display to the user for any search query. The following placeholders are available: %term%
   */
  @property()
  message = 'Search results for "%term%"';

  @state()
  private compiledMessage: HTMLElement | undefined;

  @state()
  private term!: string;

  stateChanged(state: StoreState) {
    const request = selectRequest(state);
    this.term = request?.searchTerms ?? '';
    this.compiledMessage = this.compileMessage(this.message, this.term);
    const tabSelected = state.tabbedSearchActiveTabState?.activeTabKey;
    if (tabSelected === TAB_NAMES.SUPPORT) {
      this.term = selectV2Request(state)?.searchTerms ?? '';
      this.compiledMessage = this.compileMessage('Search results for "%term%"', this.term);
    }
  }

  renderComp() {
    return html`
    <h1 class="fw-bold h4">${this.compiledMessage}</h1>
    `;
  }

  compileMessage(message: string, term: string) {
    return createMessage(message, {
      'term': term
    });
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'mhecomm-search-page-heading': SearchResultsHeading;
  }
}
